<!--
 FAQ > 글종류 수정 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical">

            <div class="uk-modal-header">
                <h4>대시보드 수정</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">

                <app-input-ex
                    class="uk-margin"
                    type="radio"
                    v-model="dashboard"
                    :options="options"
                ></app-input-ex>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * csrf token
         */
        csrfToken: {
            type: String,
            required: true,
        },


    },
    data: function () {
        return {
            /**
             * (object) FAQ 오브젝트
             **/
            faq: null,

            /**
             * (integer)
             */
            dashboard: null,

            /**
             * (Array) 글종류 옵션배열
             */
            options: null,
        };
    },
    computed: {

    },
    methods: {
        /**
         * 입력폼 display
         */
        show() {
            UIkit.modal(this.$el).show();
        },

        /**
         * 폼
         * @param faq_id FAQID
         */
        form(faq_id) {

            // promise 생성
            let load = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/faqs/' + faq_id,
                    contentType: 'application/json',
                    data: {},
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            });


            // promise 처리
            load.then((response) => {
                this.faq = response.faq;
                this.dashboard = this.faq.dashboard;
                this.options = response.dashboard_options;


                // 폼띄우기
                this.show();
            });
        },

        /**
         * submit
         */
        submit() {

            // ajax 옵션
            let opts = {
                type: 'patch',
                url: '/faqs/' + this.faq.id + '/dashboard',
                data: {
                    '_token': this.csrfToken,
                    'dashboard': this.dashboard,
                },
                success: (response, textStatus, jqXHR) => {
                    UIkit.modal.alert(response.msg).then(function () {
                        $.app.refresh();
                    });
                },
            };

            // ajax 실행
            $.app.ajax.module.default(opts);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>